
export default function Input({
    Button,
    CountryCode,
    placeholder,
    type,
    length,
    onchangeInput,
    onClickBtn,
    onKeyPress,
    value,
    loading,
    style,
    inputName,
    className,
    reder= false
}) {
    return (
        <>
            <div style={style} className={`phone-box ${ className || ""}`}>
                {CountryCode && (
                    <span className="ps-2">+91</span>
                )}
                <input
                    placeholder={placeholder}
                    type={type}
                    maxLength={length}
                    name={inputName}
                    onChange={onchangeInput}
                    value={value}
                    onKeyPress={onKeyPress}
                />
                {Button && (
                    <button onClick={onClickBtn} className="login-btn" disabled={loading}>
                        {loading ? "Loading..." : <Button />}
                    </button>
                )}
            </div>
        </>
    );
}
